import wrapError from "@/components/helpers/wrapError"
import wrapSuccess from "@/components/helpers/wrapSuccess"
import {
  createExperience,
  deleteExperience,
  updateExperience,
} from "@/components/profile/helpers/AJAXHelpers"

export const updateConstituent = (constituent, success, error) => {
  $.ajax({
    type: "PUT",
    url: `/api/admin/member/${constituent.constituentId || constituent.id}`,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(constituent),
    success,
    error: wrapError(error, "updateConstituent"),
  })
}

export const deleteConstituent = (constituentId, success, error) => {
  $.ajax({
    type: "DELETE",
    url: `/api/admin/member/${constituentId}`,
    dataType: "JSON",
    processData: false,
    data: "{}",
    contentType: "application/json; charset=utf-8",
    success,
    error: wrapError(error, "deleteConstituent"),
  })
}

export const saveConstituentAvatar = (img, constituentId, success, error) => {
  $.ajax({
    type: "POST",
    url: `/api/admin/memberAvatar/${constituentId}`,
    dataType: "JSON",
    data: { img },
    success,
    error: wrapError(error, "saveConstituentAvatar"),
  })
}

export const deleteConstituentAvatar = (constituentId, success, error) => {
  $.ajax({
    type: "DELETE",
    url: `/api/admin/memberAvatar/${constituentId}`,
    contentType: "application/json; charset=utf-8",
    success,
    error: wrapError(error, "deleteConstituentAvatar"),
  })
}

export const apiDeleteAllConstituentExperiences = (
  experienceType,
  constituentId,
  success,
  error,
) => {
  $.ajax({
    type: "POST",
    url: `/api/memberDeleteAllExperiencesManager/${constituentId}`,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ experienceType }),
    success,
    error: wrapError(error, "apiDeleteAllConstituentExperiences"),
  })
}

export const addConstituentAffinity = (affinity, constituentId, success, error) => {
  $.ajax({
    type: "POST",
    url: `/api/admin/memberAffinity/${constituentId}`,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(affinity),
    success,
    error: wrapError(error, "addConstituentAffinity"),
  })
}

export const deleteConstituentAffinity = (affinityId, constituentId, success, error) => {
  $.ajax({
    type: "DELETE",
    url: `/api/admin/memberAffinity/${constituentId}/${affinityId}`,
    contentType: "application/json; charset=utf-8",
    dataType: "JSON",
    data: "{}",
    processData: false,
    success,
    error: wrapError(error, "deleteConstituentAffinity"),
  })
}

export const addConstituentRelationship = (relationship, constituentId, success, error) => {
  $.ajax({
    type: "POST",
    url: `/api/admin/memberRelationship/${constituentId}`,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(relationship),
    success,
    error: wrapError(error, "addConstituentRelationship"),
  })
}

export const deleteConstituentRelationship = (relationshipId, constituentId, success, error) => {
  $.ajax({
    type: "DELETE",
    url: `/api/admin/memberRelationship/${constituentId}/${relationshipId}`,
    success,
    error: wrapError(error, "deleteConstituentRelationship"),
  })
}

export const fetchNotes = (constituentId, success, error) => {
  $.ajax({
    type: "GET",
    url: `/api/admin/notes/${constituentId}`,
    contentType: "application/json; charset=utf-8",
    success: wrapSuccess(success),
    error: wrapError(error, "fetchNotes"),
  })
}

export const addNotes = (data, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/notes",
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(data),
    success,
    error: wrapError(error, "addNotes"),
  })
}

export const editNote = (payload, success, error) => {
  $.ajax({
    type: "PUT",
    url: "/api/admin/notes",
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(payload),
    success,
    error: wrapError(error, "editNotes"),
  })
}
export const deleteNote = (payload, success, error) => {
  $.ajax({
    method: "DELETE",
    dataType: "JSON",
    processData: false,
    data: "{}",
    url: `/api/admin/notes/${payload.constituentId}/${payload.id}`,
    contentType: "application/json; charset=utf-8",
    success,
    error: wrapError(error, "deleteNote"),
  })
}

export const createConstituentPosition = createExperience
export const createConstituentDegree = createExperience
export const deleteConstituentPosition = deleteExperience
export const deleteConstituentDegree = deleteExperience
export const updateConstituentPosition = updateExperience
export const updateConstituentDegree = updateExperience
